import React, { useEffect, useState } from "react";
import { Button, Col, Form, InputGroup, Modal, Row } from "react-bootstrap";
import Select from 'react-select'
import { useTranslation } from "react-i18next";
import { RichText } from "src/components";
import CurrencyInput from "react-currency-input-field";
import i18next from "i18next";
import { getPlant2, getPlantV2, getRoute, getSloc } from "src/api/modules/getdatalist";
import swal from "sweetalert";
import ReactSelect from "react-select";

interface Prop {
    show: boolean
    setShow: any
    contractItems: any[]
    fullIncoterm: any[]
    leftOverQuantities: any[]
    onSubmit: (new_item: any) => void
}

const ModalAddSO: React.FC<Prop> =  ({
    show,
    setShow,
    contractItems,
    fullIncoterm,
    leftOverQuantities,
    onSubmit
})=> {
    const {t} = useTranslation()

    const [loadingForm, setLoadingForm] = useState(false)
    const [fullRoute, setFullRoute] = useState<any>([])
    const [fullPlant, setFullPlant] = useState<any>([])
    const [fullSloc, setFullSloc] = useState<any>([])
    const [tipeProduct, setTipeProduct] = useState<string>("")
    const [unitProduct, setUnitProduct] = useState<string>("")
    const [itemSelected, setItemSelected] = useState<any>()
    const [leftOverQty, setLeftOverQty] = useState<any>(0)

    const [route, setRoute] = useState('')
    const [route_desc, setRouteDesc] = useState('')
    const [plant, setPlant] = useState('')
    const [plant_desc, setPlantDesc] = useState('')
    const [sloc, setSloc] = useState('')
    const [sloc_description, setSlocDescription] = useState('')
    const [product_spec, setProductSpec] = useState('')
    const [quantity, setQuantity] = useState(0)
    const [shipping_tolerance, setShippingTolerance] = useState(0)
    const [notes, setNotes] = useState('')

    const [incoterm, setIncoterm] = useState<any>(null)
    const [incoterm2, setIncoterm2] = useState<any>(null)

    const language = i18next.language

    const fetchRoutes = () => {
        getRoute(itemSelected?.sales_org_code).then((res: any) => {
        setFullRoute(
            res.data.data.map((item: any) => {
            return {
                value: item.route + '|||' + item.route_desc,
                label: item.route + ' - ' + item.route_desc,
            }
            })
        )
        })
    }
    const fetchPlants = async () => {
      setLoadingForm(true)
        await getPlantV2(itemSelected?.sales_org_code, itemSelected?.material_number).then((res: any) => {
            let temparray: any[] = [{value: 0 + '|||', label: t('Pilih-plant')}]
            res.data.data.forEach((item: any) => {
              temparray.push({
                value: item.plant + '|||' + item.plant_name,
                label: item.plant + ' - ' + item.plant_name,
              })
            })
            setFullPlant(temparray)
        })
      setLoadingForm(false)
    }

    const fetchSlocs = () => {
        getSloc(plant, '', itemSelected?.material_number, '', '').then((res: any) => {
            setFullSloc(
              res.data.data.map((item: any) => {
                return {
                  value: item.sloc + '|||' + item.sloc_description,
                  label: item.sloc + '-' + item.sloc_description,
                }
              })
            )
          })
    }

    useEffect(() => {
      if (itemSelected) {
        setLeftOverQty(leftOverQuantities.find((item:  any) => item.order_sub_detail_id == itemSelected?.id)?.left_over_quantum || 0)
        fetchRoutes()
        fetchPlants()
        setIncoterm(itemSelected?.incoterm1_id)

        let inc2 = fullIncoterm.find((item: any) => item.value == itemSelected?.incoterm2_id)
        setIncoterm2(inc2?.label || itemSelected?.incoterm2_id) 
      }
    }, [itemSelected])

    const selectItem = (e: any) => {
      const itemSelect = contractItems.find((item: any) => item.id == e?.target?.value)
      setItemSelected(itemSelect)
      setTipeProduct(itemSelect?.order_sub_detail?.product_type)
      setUnitProduct(itemSelect?.order_sub_detail?.unit)
      setPlant(itemSelect?.plant)
      setPlantDesc(itemSelect?.plant_desc)
      setSloc(itemSelect?.sloc)
      setSlocDescription(itemSelect?.sloc_description)
      setProductSpec(itemSelect?.product_spec)
      setProductSpec(itemSelect?.product_spec)
      setNotes(itemSelect?.notes)
    }

    const clearForm = () =>{
      setItemSelected(null)
      setPlant('')
      setPlantDesc('')
      setProductSpec('')
      setLeftOverQty(0)
    }

    const setMultipleState = (value: any, state1: any, state2: any) => {
      const temp = value.split('|||')
      state1(temp[0])
      state2(temp[1])
    }

    useEffect(() => {
      if (plant) fetchSlocs()
    }, [plant])

    const storeItem = () => {
      if (!quantity) {
        swal({
          title: t('Kuantum tidak boleh kosong!'),
          icon: 'error',
        })
      } else if (quantity > leftOverQty) {
        swal({
          title: t('Melebihi quantum yang di setujui!'),
          icon: 'error',
        })
      } else {
        let inc1 = fullIncoterm.find((item: any) => {
          let expl = item.value?.split("~#~")
          return expl[0] == incoterm
        })
        onSubmit({
          id: itemSelected.id,
          order_sub_item_id: itemSelected.order_sub_item_id || itemSelected.id,
          route,
          route_desc,
          plant,
          plant_desc,
          sloc,
          sloc_description,
          shipping_tolerance,
          note: notes,
          product_spec,
          quantity,
          pph22: itemSelected?.pph22,
          ppn: itemSelected?.ppn,
          price: itemSelected?.price_contract,
          price_after_ppn: Math.round(quantity * (Math.round(itemSelected?.price_contract) + Math.round((itemSelected?.price_contract / 100) * itemSelected?.ppn))),
          price_before_ppn: (quantity * itemSelected?.price_contract),
          amount_of_pph22 : 0,
          amount_of_ppn: 0,
          quantum_do: 0,
          sap_so_item_number: null,
          segment_code: itemSelected?.segment_code,
          segment_name: itemSelected?.segment_name,
          incoterm1_id: incoterm,
          incoterm2_id : incoterm2,
          incoterm2 : null,
          left_over_quantum_without_self : 0,
          incoterm1: inc1 ? {
            id: incoterm,
            code: inc1?.label
          } : null,
          order_sub_detail: itemSelected
        })
        clearForm()
        swal({
          title: `${t('dataBerhasilDiedit')}`,
          icon: 'success',
        })
      }
    }

    return (
        <>
            <Modal
              show={show}
              onHide={() => {
                setShow(false)
                clearForm()
              }}
              backdrop='static'
              keyboard={false}
              centered
              size='lg'
              scrollable
            >
              <Modal.Header closeButton>
                <Modal.Title>{t('Tambah-SO')}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Row className='mb-3'>
                  <Col md={4}>
                    <Form.Label className='mt-3'>ID Sub SO</Form.Label>
                  </Col>
                  <Col md={8}>
                    <Form.Select
                      size='sm'
                      aria-label='Default select example'
                      onChange={selectItem}
                    >
                      <option selected>{t('pilih')} ID Sub SO</option>
                      {contractItems.map((item: any, _index: number) => (
                        <>
                          {leftOverQuantities.find((x: any) => x.order_sub_detail_id == item.id).left_over_quantum > 0 && (
                            <option key={item?.id ?? _index} value={item.id}>
                              {`${item.id} - ${item.product_name} - ${item.fixed_quantum} ton`}
                            </option>
                          )}
                        </>
                      ))}
                    </Form.Select>
                  </Col>
                </Row>

                <Row className='mb-3'>
                    <Col md={4}>
                    <Form.Label className='mt-3'>{t('Route')}</Form.Label>
                    </Col>
                    <Col md={8}>
                    <Select
                        key={itemSelected}
                        placeholder={t('pilih')}
                        onChange={(e: any) => {
                          setMultipleState(e?.value, setRoute, setRouteDesc)
                        }}
                        options={fullRoute}
                    />
                    </Col>
                </Row>

                {/* <Row className='mb-3'>
                  <Col md={4}>
                    <Form.Label className='mt-3'>Incoterm</Form.Label>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      size='sm'
                      aria-label='Default select example'
                      value={(itemSelected?.incoterm1?.code || '') + (
                        (itemSelected?.incoterm2?.code || itemSelected?.incoterm2_id) ? ` - ${(itemSelected?.incoterm2?.code || itemSelected?.incoterm2_id)}` : ''
                      )}
                      disabled
                    />
                  </Col>
                </Row> */}
                  <Row className='mb-3'>
                    <Col md={4}>
                      <Form.Label className='mt-3'>Incoterm</Form.Label>
                    </Col>
                    <Col md={8}>
                      {/* <Form.Control size='sm' aria-label='Default select example' value={incotermCode} disabled /> */}
                      <ReactSelect
                        placeholder={t('pilih')}
                        value={fullIncoterm.find((item: any) => {
                          let expl = item.value?.split("~#~")
                          return expl[0] == incoterm
                        })}
                        options={fullIncoterm}
                        onChange={(option: any) => {
                          let expl = option.value?.split("~#~")
                          setIncoterm(expl[0])
                        }}
                      />
                    </Col>
                  </Row>
                  <Row className='mb-3'>
                    <Col md={4}>
                      <Form.Label className='mt-3'>Incoterm 2</Form.Label>
                    </Col>
                    <Col md={8}>
                      <Form.Control onChange={(e: any) => setIncoterm2(e.target?.value)} size='sm' aria-label='Default select example' value={incoterm2} />
                    </Col>
                  </Row>

                  <>
                    <Row className='mb-3'>
                      <Col md={4}>
                        <Form.Label className='mt-3'>{t('Plant')}</Form.Label>
                      </Col>
                      <Col md={8}>
                        <Select
                          key={itemSelected}
                          placeholder={t('pilih')}
                          onChange={(e: any) => {
                            setMultipleState(e.value, setPlant, setPlantDesc)
                            setSloc('')
                            setSlocDescription('')
                          }}
                          options={fullPlant}
                          value={fullPlant.find((item: any) => item.value == `${plant}|||${plant_desc}`)}
                        />
                      </Col>
                    </Row>
                    <Row className='mb-3'>
                      <Col md={4}>
                        {i18next.language === 'en' ? (
                          <>
                            <Form.Label className='mt-3'>{t('storage location')}</Form.Label>
                          </>
                        ) : (
                          <>
                            <Form.Label className=''>{t('storage location')}</Form.Label>
                          </>
                        )}
                      </Col>
                      <Col md={8}>
                        <Select
                          placeholder={t('pilih')}
                          onChange={(e: any) => {
                            setMultipleState(e?.value, setSloc, setSlocDescription)
                          }}
                          options={fullSloc}
                        />
                      </Col>
                    </Row>
                  </>

                <Row className='mb-3'>
                  <Col md={4}>
                    <Form.Label className='mt-3'>{t('sub-order-jenis')}</Form.Label>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      size='sm'
                      aria-label='Default example'
                      value={`${(itemSelected?.product_type || '')} - ${(itemSelected?.product_type_desc || '')}`}
                      disabled
                    />
                  </Col>
                </Row>

                <Row className='mb-3'>
                  <Col md={4}>
                    <Form.Label className='mt-3'>{t('Product Name')}</Form.Label>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      aria-label='Default example'
                      size='sm'
                      value={`${(itemSelected?.material_number ? parseInt(itemSelected?.material_number) : '')} - ${(itemSelected?.product_name || '')}`}
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mb-3'>
                  <Col md={4}>
                    <Form.Label className='mt-3'>{t('Product Specification')}</Form.Label>
                  </Col>
                  <Col md={8}>
                    <div>
                      <RichText
                          containerClassName='mt-4'
                          content={product_spec}
                          onUpdate={({editor}) => {
                              setProductSpec(editor.getHTML())
                          }}
                      >
                          &nbsp;
                      </RichText>
                    </div>
                  </Col>
                </Row>

                <Row className='mb-3'>
                  <Col md={4} className='d-flex align-items-center'>
                    <Form.Label>
                      { t('contract-price') }
                    </Form.Label>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      aria-label='Default select example'
                      disabled
                      size='sm'
                      value={'Rp ' + itemSelected ? 
                        (new Intl.NumberFormat(
                          i18next.language === 'en' ? 'en' : 'id'
                        ).format(Number(itemSelected?.price_contract || 0))) + (
                          itemSelected?.sector_id === 3
                            ? ' /MT'
                            : ' /Ton'
                        ) : ''
                      }
                    />
                  </Col>
                </Row>
                
                <Row className='mb-3'>
                  <Col md={4} className='d-flex align-items-center'>
                    <Form.Label>
                      {tipeProduct == '8105'
                        ? t('sisakantong')
                        : t('CREATE_SO.ADD_SO_MODAL.QUANTUM_CONTRACT_LABEL')}
                    </Form.Label>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                        aria-label='Default select example'
                        disabled
                        size='sm'
                        value={
                          itemSelected ? 
                          `${new Intl.NumberFormat(
                            i18next.language === 'en' ? 'en' : 'id'
                          ).format(Number(itemSelected?.quantum_contract))} Ton (+/- ${
                            itemSelected?.shipping_tolerance_contract ?? 0
                          }%)` : ''
                        }
                    />
                  </Col>
                </Row>

                <Row className='mb-3'>
                  <Col md={4} className='d-flex align-items-center'>
                    <Form.Label>{t('CREATE_SO.ADD_SO_MODAL.KUANTUM_SO_RILIS_LABEL')}</Form.Label>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      aria-label='Default select example'
                      disabled
                      size='sm'
                      value={itemSelected ? itemSelected.so_qty_realized + ' Ton' : ''}
                    />
                  </Col>
                </Row>

                <Row className='mb-3'>
                  <Col md={4} className='d-flex align-items-center'>
                    <Form.Label>{t('sisaquantum')}</Form.Label>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      aria-label='Default select example'
                      disabled
                      size='sm'
                      value={new Intl.NumberFormat(
                        i18next.language === 'en' ? 'en' : 'id'
                      ).format(Number(leftOverQty)) + ' Ton'}
                    />
                  </Col>
                </Row>

                <Row className='mb-3'>
                  <Col md={4} className='d-flex align-items-center'>
                    <Form.Label>
                      {tipeProduct == '8105' ? t('sack') : t('sub-order-kuantum') + ' SO'}
                    </Form.Label>
                  </Col>
                  <Col md={8}>
                    <InputGroup size='sm'>
                      <CurrencyInput
                        className='form-control form-control-sm'
                        id='kuantum'
                        placeholder={tipeProduct == '8105' ? t('sack') : t('sub-order-kuantum')}
                        decimalSeparator={language === 'en' ? '.' : ','}
                        groupSeparator={language === 'en' ? ',' : '.'}
                        onValueChange={(value: any) => {
                          setQuantity((parseFloat(value?.replace(/,/g, '.'))))
                        }}
                        decimalsLimit={3}
                      />
                      <InputGroup.Text id='basic-addon2'>
                        {tipeProduct == '8105' ? unitProduct : 'Ton'}
                      </InputGroup.Text>
                    </InputGroup>
                  </Col>
                </Row>

                <Row className='mb-3'>
                  <Col md={4} className='d-flex align-items-center'>
                    <Form.Label>
                      {t('CREATE_SO.ADD_SO_MODAL.TOLERANCE_QUANTUM_SO_LABEL')}
                    </Form.Label>
                  </Col>
                  <Col md={8}>
                    <InputGroup size='sm'>
                      <CurrencyInput
                          className='form-control form-control-sm'
                          decimalSeparator={i18next.language === 'en' ? '.' : ','}
                          groupSeparator={i18next.language === 'en' ? ',' : '.'}
                          decimalsLimit={3}
                          onValueChange={(v: any) => {
                              setShippingTolerance(parseFloat(v?.replace(/,/g, '.')))
                          }}
                      />
                      <InputGroup.Text
                        id='basic-addon2'
                        style={{paddingTop: '1px', paddingBottom: '1px'}}
                      >
                        <span style={{padding: '0 6.5px'}}>%</span>
                      </InputGroup.Text>
                    </InputGroup>
                  </Col>
                </Row>

                <Row className='mb-3'>
                  <Col md={4}>
                    <Form.Label className='mt-3'>{t('sub-order-catatan')}</Form.Label>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      size='sm'
                      placeholder={t('sub-order-catatan')}
                      type='text'
                      as='textarea'
                      onChange={(e: any) => setNotes(e?.target?.value)}
                    />
                  </Col>
                </Row>

                <div className='d-flex justify-content-end mt-5'>
                  <Button
                    variant='primary'
                    onClick={storeItem}
                  >
                    {t('Save')}
                  </Button>
                </div>
                {/* </>
                    )} */}
              </Modal.Body>
            </Modal>
        </>
    )
}

export default ModalAddSO;